import stats from '@/api/statistics'
import { mergeUserContext } from '@/store/helpers'
import { translateIndicators } from '@/helpers/cseit'

const colorValues = require('./data/legendColors.json')

// initial state
const state = {
  indicatorcount: [],
  assessmentIndicators: [],
  assessmentIndicatorsByPerson: [],
  generalCounts: {
    'personCount': 0,
    'confirmedPersonCount': 0,
    'possiblePersonCount': 0,
    'cseitCount': 0,
    'cseitCountNoConcern': 0,
    'cseitCountPossibleConcern': 0,
    'cseitCountClearConcern': 0,
    'cseitCountAllPerson': 0,
    'cseitCountNoConcernPerson': 0,
    'cseitCountPossibleConcernPerson': 0,
    'cseitCountClearConcernPerson': 0,
    'assessmentCount': 0,
    'assessmentCountNotEnoughInfo': 0,
    'assessmentCountPossible': 0,
    'assessmentCountPerson': 0,
    'assessmentCountNotEnoughInfoPerson': 0,
    'assessmentCountPossiblePerson': 0,
    'lsCount': 0,
    'lsCountNotEnoughInfo': 0,
    'lsCountVulnerable': 0,
    'lsCountHighlyVulnerable': 0,
    'lsCountAllPerson': 0,
    'lsCountNotEnoughInfoPerson': 0,
    'lsCountVulnerablePerson': 0,
    'lsCountHighlyVulnerablePerson': 0
  },
  personCountsByTime: [],
  personCountsByDemographic: [],
  cseitCountsByTime: [],
  lsCountsByTime: [],
  cseitCountsByIndicators: [],
  assessmentCountsByTime: [],
  personDemographicsByTime: [],
  personDemographicsByTimeUnconfirmed: [],
  personDemographicsByTimeConfirmed: [],
  cseitDemographicsByTime: [],
  cseitDemographicsByTimeNoConcern: [],
  cseitDemographicsByTimePossibleConcern: [],
  cseitDemographicsByTimeClearConcern: [],
  lsDemographicsByTime: [],
  lsDemographicsByTimeError: false,
  assessmentDemographicsByTime: [],
  assessmentsByLocationForMap: [],
  cseitCountsByDemographic: [],
  lsCountsByDemographic: [],
  lsCountsByDemographicError: false,
  assessmentCountsByDemographic: [],
  assessmentDemographicsByTimeNoInfoVictims: [],
  assessmentDemographicsByTimePossibleVictims: [],
  cseitIndicators: [],
  lsIndicators: [],
  lsIndicatorsError: false,
  colorValues: colorValues.items,
  personCountsByTimeError: false,
  personCountsByDemographicError: false,
  personDemographicsByTimeError: false,
  personDemographicsOverTimeUnconfirmedError: false,
  personDemographicsOverTimeConfirmedError: false,
  cseitCountsByTimeError: false,
  lsCountsByTimeError: false,
  cseitCountsByDemographicError: false,
  cseitDemographicsByTimeError: false,
  cseitDemographicsOverTimeNoConcernError: false,
  cseitDemographicsOverTimePossibleConcernError: false,
  cseitDemographicsOverTimeClearConcernError: false,
  assessmentCountsByTimeError: false,
  assessmentByDemographicError: false,
  assessmentDemographicsByTimeError: false,
  assessmentDemographicsOverTimeNoInfoError: false,
  assessmentDemographicsOverTimePossibleError: false,
  assessmentIndicatorsError: false,
  cseitIndicatorsError: false,
  statisticsScreeningsByOrgError: false,
  statisticsScreeningsByOrg: [],
  statisticsLaborScreeningsByOrgError: false,
  statisticsLaborScreeningsByOrg: []
}

// getters
const getters = {
  getAssessmentIndicators: state => state.assessmentIndicators,
  getAssessmentIndicatorsByPerson: state => state.assessmentIndicatorsByPerson,
  indicatorCount: state => state.indicatorcount,
  getGeneralCounts: state => state.generalCounts,
  getPersonCountsByTime: state => state.personCountsByTime,
  getAssessmentCountsByTime: state => state.assessmentCountsByTime,
  getCseitCountsByTime: state => state.cseitCountsByTime,
  getLaborScreeningCountsByTime: state => state.lsCountsByTime,
  getPersonCountsByDemographic: state => state.personCountsByDemographic,
  getCseitCountsByIndicators: state => state.cseitCountsByIndicators,
  getPersonDemographicsByTime: state => state.personDemographicsByTime,
  getPersonDemographicsByTimeUnconfirmed: state => state.personDemographicsByTimeUnconfirmed,
  getPersonDemographicsByTimeConfirmed: state => state.personDemographicsByTimeConfirmed,
  getCseitCountsByDemographic: state => state.cseitCountsByDemographic,
  getLaborScreeningCountsByDemographic: state => state.lsCountsByDemographic,
  getAssessmentCountsByDemographic: state => state.assessmentCountsByDemographic,
  getMapsMarkers: state => state.assessmentsByLocationForMap,
  getAssessmentDemographicsByTime: state => state.assessmentDemographicsByTime,
  getAssessmentDemographicsByTimeNoInfoVictims: state => state.assessmentDemographicsByTimeNoInfoVictims,
  getAssessmentDemographicsByTimePossibleVictims: state => state.assessmentDemographicsByTimePossibleVictims,
  getCseitDemographicsByTime: state => state.cseitDemographicsByTime,
  getCseitDemographicsByTimeNoConcern: state => state.cseitDemographicsByTimeNoConcern,
  getCseitDemographicsByTimePossibleConcern: state => state.cseitDemographicsByTimePossibleConcern,
  getCseitDemographicsByTimeClearConcern: state => state.cseitDemographicsByTimeClearConcern,
  getCseitIndicators: state => state.cseitIndicators,
  getLaborScreeningIndicators: state => state.lsIndicators,
  getLaborScreeningIndicatorsError: state => state.lsIndicatorsError,
  getColorValues: state => {
    return state.colorValues
  },
  getPersonCountsByTimeError: state => state.personCountsByTimeError,
  getPersonCountsByDemographicError: state => state.personCountsByDemographicError,
  getPersonDemographicsByTimeError: state => state.personDemographicsByTimeError,
  getPersonDemographicsOverTimeUnconfirmedError: state => state.personDemographicsOverTimeUnconfirmedError,
  getPersonDemographicsOverTimeConfirmedError: state => state.personDemographicsOverTimeConfirmedError,
  getCseitCountsByTimeError: state => state.cseitCountsByTimeError,
  getLaborScreeningCountsByTimeError: state => state.lsCountsByTimeError,
  getCseitCountsByDemographicError: state => state.cseitCountsByDemographicError,
  getLaborScreeningCountsByDemographicError: state => state.lsCountsByDemographicError,
  getCseitDemographicsByTimeError: state => state.cseitDemographicsByTimeError,
  getCseitDemographicsOverTimeNoConcernError: state => state.cseitDemographicsOverTimeNoConcernError,
  getCseitDemographicsOverTimePossibleConcernError: state => state.cseitDemographicsOverTimePossibleConcernError,
  getCseitDemographicsOverTimeClearConcernError: state => state.cseitDemographicsOverTimeClearConcernError,
  getAssessmentCountsByTimeError: state => state.assessmentCountsByTimeError,
  getAssessmentByDemographicError: state => state.assessmentByDemographicError,
  getAssessmentDemographicsByTimeError: state => state.assessmentDemographicsByTimeError,
  getAssessmentDemographicsOverTimeNoInfoError: state => state.assessmentDemographicsOverTimeNoInfoError,
  getAssessmentDemographicsOverTimePossibleError: state => state.assessmentDemographicsOverTimePossibleError,
  getAssessmentIndicatorsError: state => state.assessmentIndicatorsError,
  getCseitIndicatorsError: state => state.cseitIndicatorsError,
  getStatisticsScreeningsByOrgError: state => state.statisticsScreeningsByOrgError,
  getStatisticsScreeningsByOrg: state => state.statisticsScreeningsByOrg,
  getStatisticsLaborScreeningsByOrgError: state => state.statisticsLaborScreeningsByOrgError,
  getStatisticsLaborScreeningsByOrg: state => state.statisticsLaborScreeningsByOrg,
  getLaborScreeningDemographicsByTime: state => state.lsDemographicsByTime,
  getLaborScreeningDemographicsByTimeError: state => state.lsDemographicsByTimeError
}

// actions
const actions = {
  async getAssessmentIndicators ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await stats.getAssessmentIndicators(payload)
    response = response.body

    if (response === 'No permissible assessments records') {
      commit('setAssessmentIndicatorsError', true)
    } else {
      commit('setAssessmentIndicators', response)
      commit('setAssessmentIndicatorsError', false)
    }
  },

  async getAssessmentIndicatorsByPerson ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await stats.getAssessmentIndicatorsByPerson(payload)
    response = response.body

    const formattedResponse = _.map(response, (stat) => {
      if (stat.groupByValue === '') {
        stat.groupByValue = 'Not Specified'
      }
      return stat
    })

    commit('setAssessmentIndicatorsByDemographic', formattedResponse)
  },

  async getGeneralCounts ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await stats.getGeneralCounts(payload)
    response = response.body

    commit('setGeneralCounts', response)
  },

  async getAssessmentCountsByTime ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await stats.getAssessmentCountsByTime(payload)
    response = response.body

    if (response === 'No permissible assessments records') {
      commit('setAssessmentCountsByTimeError', true)
    } else {
      commit('setAssessmentCountsByTime', response)
      commit('setAssessmentCountsByTimeError', false)
    }
  },

  async getCseitCountsByTime ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await stats.getCseitCountsByTime(payload)
    response = response.body

    if (response === 'No permissible cseit records') {
      commit('setCseitCountsByTimeError', true)
    } else {
      commit('setCseitCountsByTime', response)
      commit('setCseitCountsByTimeError', false)
    }
  },

  async getLaborScreeningCountsByTime ({ commit, rootState }, payload) {
    try {
      payload = mergeUserContext(payload, rootState)
      const response = await stats.getLaborScreeningCountsByTime(payload)
      if (!response.ok) {
        throw new Error()
      }
      commit('setLsCountsByTime', response.body)
      commit('setLsCountsByTimeError', false)
    } catch (error) {
      commit('setCseitCountsByTimeError', true)
    }
  },

  async getPersonCountsByTime ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await stats.getPersonCountsByTime(payload)
    response = response.body

    if (response === 'No permissible person records') {
      commit('setPersonCountsByTimeError', true)
    } else {
      commit('setPersonCountsByTime', response)
      commit('setPersonCountsByTimeError', false)
    }
  },

  async getPersonCountsByDemographic ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await stats.getPersonCountsByDemographic(payload)
    response = response.body

    if (response === 'No permissible person records') {
      commit('setPersonCountsByDemographicError', true)
    } else {
      commit('setPersonCountsByDemographic', response)
      commit('setPersonCountsByDemographicError', false)
    }
  },

  async getCseitCountsByIndicators ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await stats.getCseitIndicatorsByPerson(payload)
    response = response.body

    commit('setCseitCountsByIndicators', response)
  },

  async getMapsMarkers ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await stats.getAssessmentsByLocationForMap()
    response = response.body

    commit('setAssessmentsByLocationForMap', response)
  },

  async getPersonDemographicsByTime ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await stats.getPersonDemographicsOverTime(payload)
    response = response.body

    if (response === 'No permissible person records') {
      commit('setPersonDemographicsOverTimeError', true)
    } else {
      commit('setPersonDemographicsOverTime', response)
      commit('setPersonDemographicsOverTimeError', false)
    }
  },

  async getPersonDemographicsByTimeUnconfirmed ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await stats.getPersonDemographicsOverTime(payload)
    response = response.body

    if (response === 'No permissible person records') {
      commit('setPersonDemographicsOverTimeUnconfirmedError', true)
    } else {
      commit('setPersonDemographicsOverTimeUnconfirmed', response)
      commit('setPersonDemographicsOverTimeUnconfirmedError', false)
    }
  },

  async getPersonDemographicsByTimeConfirmed ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await stats.getPersonDemographicsOverTime(payload)
    response = response.body

    if (response === 'No permissible person records') {
      commit('setPersonDemographicsOverTimeConfirmedError', true)
    } else {
      commit('setPersonDemographicsOverTimeConfirmed', response)
      commit('setPersonDemographicsOverTimeConfirmedError', false)
    }
  },

  async getCseitCountsByDemographic ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await stats.getCseitCountsByDemographic(payload)
    response = response.body

    if (response === 'No permissible cseit records') {
      commit('setCseitCountsByDemographicError', true)
    } else {
      commit('setCseitCountsByDemographic', response)
      commit('setCseitCountsByDemographicError', false)
    }
  },

  async getLaborScreeningCountsByDemographic ({ commit, rootState }, payload) {
    try {
      payload = mergeUserContext(payload, rootState)
      const response = await stats.getLaborScreeningCountsByDemographic(payload)
      if (!response.ok) {
        throw new Error()
      }
      commit('setLaborScreeningCountsByDemographic', response.body)
      commit('setLaborScreeningCountsByDemographicError', false)
    } catch (error) {
      commit('setLaborScreeningCountsByDemographicError', true)
    }
  },

  async getAssessmentCountsByDemographic ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await stats.getAssessmentCountsByDemographic(payload)
    response = response.body

    if (response === 'No permissible assessments records') {
      commit('setAssessmentByDemographicError', true)
    } else {
      commit('setAssessmentCountsByDemographic', response)
      commit('setAssessmentByDemographicError', false)
    }
  },

  async getAssessmentDemographicsByTime ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await stats.getAssessmentDemographicsOverTime(payload)
    response = response.body

    if (response === 'No permissible assessments records') {
      commit('setAssessmentDemographicsByTimeError', true)
    } else {
      commit('setAssessmentDemographicsOverTime', response)
      commit('setAssessmentDemographicsByTimeError', false)
    }
  },

  async getAssessmentDemographicsByTimeNoInfoVictims ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await stats.getAssessmentDemographicsOverTime(payload)
    response = response.body

    if (response === 'No permissible assessments records') {
      commit('setAssessmentDemographicsOverTimeNoInfoError', true)
    } else {
      commit('setAssessmentDemographicsOverTimeNoInfoVictims', response)
      commit('setAssessmentDemographicsOverTimeNoInfoError', false)
    }
  },

  async getAssessmentDemographicsByTimePossibleVictims ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await stats.getAssessmentDemographicsOverTime(payload)
    response = response.body

    if (response === 'No permissible assessments records') {
      commit('setAssessmentDemographicsOverTimePossibleError', true)
    } else {
      commit('setAssessmentDemographicsOverTimePossibleVictims', response)
      commit('setAssessmentDemographicsOverTimePossibleError', false)
    }
  },

  async getCseitDemographicsByTime ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await stats.getCseitDemographicsByTime(payload)
    response = response.body

    if (response === 'No permissible cseit records') {
      commit('setCseitDemographicsByTimeError', true)
    } else {
      commit('setCseitDemographicsByTime', response)
      commit('setCseitDemographicsByTimeError', false)
    }
  },

  async getCseitDemographicsByTimeNoConcern ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await stats.getCseitDemographicsByTime(payload)
    response = response.body

    if (response === 'No permissible cseit records') {
      commit('setCseitDemographicsOverTimeNoConcernError', true)
    } else {
      commit('setCseitDemographicsByTimeNoConcern', response)
      commit('setCseitDemographicsOverTimeNoConcernError', false)
    }
  },

  async getCseitDemographicsByTimePossibleConcern ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await stats.getCseitDemographicsByTime(payload)
    response = response.body
    if (response === 'No permissible cseit records') {
      commit('setCseitDemographicsOverTimePossibleConcernError', true)
    } else {
      commit('setCseitDemographicsByTimePossibleConcern', response)
      commit('setCseitDemographicsOverTimePossibleConcernError', false)
    }
  },

  async getCseitDemographicsByTimeClearConcern ({ commit, state, rootState }, payload) {
    let response = await stats.getCseitDemographicsByTime(payload)
    response = response.body
    if (response === 'No permissible cseit records') {
      commit('setCseitDemographicsOverTimeClearConcernError', true)
    } else {
      commit('setCseitDemographicsByTimeClearConcern', response)
      commit('setCseitDemographicsOverTimeClearConcernError', false)
    }
  },

  async getLaborScreeningDemographicsByTime ({ commit, rootState }, payload) {
    try {
      payload = mergeUserContext(payload, rootState)
      const response = await stats.getLaborScreeningDemographicsByTime(payload)
      if (!response.ok) {
        throw new Error()
      }
      commit('setLaborScreeningDemographicsByTime', response.body)
      commit('setLaborScreeningDemographicsByTimeError', false)
    } catch (error) {
      commit('setLaborScreeningDemographicsByTimeError', true)
    }
  },

  async getCseitIndicators ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await stats.getCseitIndicators(payload)
    response = response.body

    if (response === 'No permissible cseit records') {
      commit('setCseitIndicatorsError', true)
    } else {
      response.forEach((value, index) => {
        let translation = translateIndicators(value.field)
        response[index].field = translation
      })
      commit('setCseitIndicators', response)
      commit('setCseitIndicatorsError', false)
    }
  },

  async getLaborScreeningIndicators ({ commit, rootState }, payload) {
    try {
      payload = mergeUserContext(payload, rootState)
      const response = await stats.getLaborScreeningIndicators(payload)
      if (!response.ok) {
        throw new Error()
      }

      commit('setLaborScreeningIndicators', response.body)
      commit('setLaborScreeningIndicatorsError', false)
    } catch (error) {
      commit('setLaborScreeningIndicatorsError', true)
    }
  },

  async getStatisticsScreeningsByOrg ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await stats.getScreeningsByOrg(payload)
    response = response.body
    if (response === 'No records') {
      commit('setStatisticsScreeningsByOrgError', true)
    } else {
      commit('setStatisticsScreeningsByOrg', response)
      commit('setStatisticsScreeningsByOrgError', false)
    }
  },

  async getStatisticsLaborScreeningsByOrg ({ commit, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await stats.getLaborScreeningsByOrg(payload)
    response = response.body
    if (response === 'No records') {
      commit('setStatisticsLaborScreeningsByOrgError', true)
    } else {
      commit('setStatisticsLaborScreeningsByOrg', response)
      commit('setStatisticsLaborScreeningsByOrgError', false)
    }
  }
}

// mutations
const mutations = {
  setIndicatorCount (state, payload) {
    if (typeof payload !== 'undefined') {
      state.indicatorcount = payload
    }
  },

  setAssessmentIndicatorsByDemographic (state, payload) {
    state.assessmentIndicatorsByPerson = payload
  },

  setAssessmentIndicators (state, payload) {
    state.assessmentIndicators = payload
  },

  setGeneralCounts (state, payload) {
    state.generalCounts = payload
  },

  setAssessmentCountsByTime (state, payload) {
    state.assessmentCountsByTime = payload
  },

  setPersonCountsByTime (state, payload) {
    state.personCountsByTime = payload
  },

  setPersonCountsByDemographic (state, payload) {
    state.personCountsByDemographic = payload
  },

  setCseitCountsByIndicators (state, payload) {
    state.cseitCountsByIndicators = payload
  },

  setCseitCountsByTime (state, payload) {
    state.cseitCountsByTime = payload
  },

  setLsCountsByTime (state, payload) {
    state.lsCountsByTime = payload
  },

  setLsCountsByTimeError (state, payload) {
    state.lsCountsByTimeError = payload
  },

  setLaborScreeningDemographicsByTimeError (state, payload) {
    state.lsDemographicsByTimeError = payload
  },

  setLaborScreeningDemographicsByTime (state, payload) {
    state.lsDemographicsByTime = payload
  },

  setAssessmentsByLocationForMap (state, payload) {
    state.assessmentsByLocationForMap = payload
  },

  setPersonDemographicsOverTime (state, payload) {
    state.personDemographicsByTime = payload
  },

  setPersonDemographicsOverTimeUnconfirmed (state, payload) {
    state.personDemographicsByTimeUnconfirmed = payload
  },

  setPersonDemographicsOverTimeConfirmed (state, payload) {
    state.personDemographicsByTimeConfirmed = payload
  },

  setCseitCountsByDemographic (state, payload) {
    state.cseitCountsByDemographic = payload
  },

  setLaborScreeningCountsByDemographic (state, payload) {
    state.lsCountsByDemographic = payload
  },

  setAssessmentCountsByDemographic (state, payload) {
    state.assessmentCountsByDemographic = payload
  },

  setAssessmentDemographicsOverTime (state, payload) {
    state.assessmentDemographicsByTime = payload
  },

  setAssessmentDemographicsOverTimeNoInfoVictims (state, payload) {
    state.assessmentDemographicsByTimeNoInfoVictims = payload
  },

  setAssessmentDemographicsOverTimePossibleVictims (state, payload) {
    state.assessmentDemographicsByTimePossibleVictims = payload
  },

  setCseitDemographicsByTime (state, payload) {
    state.cseitDemographicsByTime = payload
  },

  setCseitDemographicsByTimeNoConcern (state, payload) {
    state.cseitDemographicsByTimeNoConcern = payload
  },

  setCseitDemographicsByTimePossibleConcern (state, payload) {
    state.cseitDemographicsByTimePossibleConcern = payload
  },

  setCseitDemographicsByTimeClearConcern (state, payload) {
    state.cseitDemographicsByTimeClearConcern = payload
  },

  setCseitIndicators (state, payload) {
    state.cseitIndicators = payload
  },

  setLaborScreeningIndicators (state, payload) {
    state.lsIndicators = payload
  },

  setLaborScreeningIndicatorsError (state, payload) {
    state.lsIndicatorsError = payload
  },

  setPersonCountsByTimeError (state, payload) {
    state.personCountsByTimeError = payload
  },

  setPersonCountsByDemographicError (state, payload) {
    state.personCountsByDemographicError = payload
  },

  setPersonDemographicsOverTimeError (state, payload) {
    state.personDemographicsByTimeError = payload
  },

  setPersonDemographicsOverTimeUnconfirmedError (state, payload) {
    state.personDemographicsOverTimeUnconfirmedError = payload
  },

  setPersonDemographicsOverTimeConfirmedError (state, payload) {
    state.personDemographicsOverTimeConfirmedError = payload
  },

  setCseitCountsByTimeError (state, payload) {
    state.cseitCountsByTimeError = payload
  },

  setCseitCountsByDemographicError (state, payload) {
    state.cseitCountsByDemographicError = payload
  },

  setLaborScreeningCountsByDemographicError (state, payload) {
    state.lsCountsByDemographicError = payload
  },

  setCseitDemographicsByTimeError (state, payload) {
    state.cseitDemographicsByTimeError = payload
  },

  setCseitDemographicsOverTimeNoConcernError (state, payload) {
    state.cseitDemographicsOverTimeNoConcernError = payload
  },

  setCseitDemographicsOverTimePossibleConcernError (state, payload) {
    state.cseitDemographicsOverTimePossibleConcernError = payload
  },

  setCseitDemographicsOverTimeClearConcernError (state, payload) {
    state.cseitDemographicsOverTimeClearConcernError = payload
  },

  setAssessmentCountsByTimeError (state, payload) {
    state.assessmentCountsByTimeError = payload
  },

  setAssessmentByDemographicError (state, payload) {
    state.assessmentByDemographicError = payload
  },

  setAssessmentDemographicsByTimeError (state, payload) {
    state.assessmentDemographicsByTimeError = payload
  },

  setAssessmentDemographicsOverTimeNoInfoError (state, payload) {
    state.assessmentDemographicsOverTimeNoInfoError = payload
  },

  setAssessmentDemographicsOverTimePossibleError (state, payload) {
    state.assessmentDemographicsOverTimePossibleError = payload
  },

  setAssessmentIndicatorsError (state, payload) {
    state.assessmentIndicatorsError = payload
  },

  setCseitIndicatorsError (state, payload) {
    state.cseitIndicatorsError = payload
  },

  setStatisticsScreeningsByOrgError (state, payload) {
    state.statisticsScreeningsByOrgError = payload
  },

  setStatisticsScreeningsByOrg (state, payload) {
    state.statisticsScreeningsByOrg = payload
  },

  setStatisticsLaborScreeningsByOrg (state, payload) {
    state.statisticsLaborScreeningsByOrg = payload
  },

  setStatisticsLaborScreeningsByOrgError (state, payload) {
    state.statisticsLaborScreeningsByOrgError = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/statistics.js